import { Stack } from '@mui/material';
import { Controller, FieldValues, useFormContext } from 'react-hook-form';

import { Checkbox } from '@/shared/components/ui/checkbox/checkbox';
import { TFormCheckboxGroupProps } from '@/shared/components/ui/form/components/form-checkbox-group/form-checkbox-group.types';
import { FormErrorMessage } from '@/shared/components/ui/form/components/form-error-message/form-error-message';
import { FormLabel } from '@/shared/components/ui/form/components/form-label/form-label';

export const FormCheckboxGroup = <TFieldValues extends FieldValues>({
  name,
  options,
  label,
  required,
  defaultValue,
}: TFormCheckboxGroupProps<TFieldValues>) => {
  const { control } = useFormContext<TFieldValues>();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState }) => {
        const selected: string[] = value ?? [];

        const handleToggle = (optionValue: string, checked: boolean) => {
          const updated = checked
            ? [...selected, optionValue]
            : selected.filter((v) => v !== optionValue);
          onChange(updated);
        };

        return (
          <Stack gap="0rem">
            {label && <FormLabel required={required} label={label} />}
            {options.map((option) => (
              <Stack
                key={option.value}
                direction="row"
                alignItems="center"
                gap="0.5rem"
                margin="-0.25rem 0rem"
              >
                <Checkbox
                  disabled={option.disabled}
                  checked={selected.includes(option.value)}
                  onChange={(event) =>
                    handleToggle(option.value, event.target.checked)
                  }
                />
                <FormLabel required label={option.label} gutterBottom={false} />
              </Stack>
            ))}
            {fieldState.error?.message && (
              <FormErrorMessage
                field={label}
                errorMessage={fieldState.error.message}
              />
            )}
          </Stack>
        );
      }}
    />
  );
};
